import React, { useMemo } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

const UserResearchReductionForm = ({
    isOpen,
    onClose,
    onSubmit,
    formData,
    setFormData,
    isEditing,
    categories,
    users,
    isAdminView
}) => {
    const categoryOptions = useMemo(() => {
        return (categories || []).map(cat => ({
            label: `${cat.Name} (Giảm ${cat.Score}%)`,
            value: cat.Id,
            score: cat.Score
        }));
    }, [categories]);

    if (!isOpen) return null;

    const isApproved = formData.Status === 'Đã duyệt';

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleCategoryChange = (e) => {
        const selectedId = e.value;

        if (selectedId) {
            const selectedOption = categoryOptions.find(opt => opt.value == selectedId);

            setFormData({
                ...formData,
                ResearchReductionId: selectedId,
                ActualPercentage: selectedOption ? selectedOption.score : ''
            });
        } else {
            setFormData({
                ...formData,
                ResearchReductionId: '',
                ActualPercentage: ''
            });
        }
    };

    const handleConcurrentCategoryChange = (e) => {
        const selectedId = e.value;

        if (selectedId) {
            const selectedOption = categoryOptions.find(opt => opt.value == selectedId);

            setFormData({
                ...formData,
                ConcurrentReductionId: selectedId,
                ConcurrentPercentage: selectedOption ? selectedOption.score : ''
            });
        } else {
            setFormData({
                ...formData,
                ConcurrentReductionId: '',
                ConcurrentPercentage: ''
            });
        }
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString, type: 'text' } });
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box" style={{ width: '90%', maxWidth: '700px', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                <div className="modal-header" style={{ flexShrink: 0 }}>
                    <h3>{isEditing ? "Cập nhật Mục giảm trừ" : "Thêm mới Mục giảm trừ giờ NCKH định mức"}</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body" style={{ overflowY: 'auto', padding: '20px' }}>
                    <form id="urrForm" onSubmit={onSubmit}>

                        {isAdminView && users && (
                            <div className="form-group" style={{ marginBottom: '20px', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', borderLeft: '4px solid #3498db' }}>
                                <label style={{ color: '#003399', fontWeight: 'bold' }}>Chọn giảng viên *</label>
                                <select
                                    name="UserId"
                                    className="form-input"
                                    value={formData.UserId || ''}
                                    onChange={handleChange}
                                    required
                                    disabled={isApproved}
                                >
                                    <option value="">Vui lòng chọn giảng viên</option>
                                    {users.map(u => {
                                        const fullName = u.FullName || ((u.LastName || '') + ' ' + (u.FirstName || '')).trim() || 'Chưa cập nhật tên';
                                        return (
                                            <option key={u.Id} value={u.Id}>
                                                {fullName} - {u.Email}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}

                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Chọn mục giảm trừ *
                            </label>
                            <Dropdown
                                id="ResearchReductionId"
                                name="ResearchReductionId"
                                value={formData.ResearchReductionId ? Number(formData.ResearchReductionId) : null}
                                options={categoryOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={handleCategoryChange}
                                placeholder="Vui lòng chọn mục giảm trừ"
                                filter
                                filterPlaceholder="Nhập từ khóa để tìm kiếm"
                                disabled={isApproved}
                                style={{
                                    width: '100%',
                                    border: '1px solid #cbd5e1',
                                    borderRadius: '6px',
                                    padding: '10px 10px'
                                }}
                                panelStyle={{ maxWidth: '650px' }}
                                itemTemplate={(option) => (
                                    <div style={{ whiteSpace: 'normal', lineHeight: '1.5' }}>
                                        {option.label}
                                    </div>
                                )}
                                emptyMessage="Không có dữ liệu"
                                emptyFilterMessage="Không tìm thấy kết quả phù hợp"
                                required
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label>Mức giảm trừ thực tế (%) *</label>
                            <input
                                type="number"
                                step="0.1"
                                name="ActualPercentage"
                                className="form-input"
                                placeholder="Nhập giá trị 0, 10, 20, ..."
                                value={formData.ActualPercentage}
                                onChange={handleChange}
                                required
                                disabled={isApproved}
                            />
                        </div>

                        <div className="form-grid-2" style={{ marginBottom: '20px' }}>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày bắt đầu *</label>
                                <Calendar
                                    id="StartDate"
                                    name="StartDate"
                                    value={(formData.StartDate && !isNaN(new Date(formData.StartDate).getTime())) ? new Date(formData.StartDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('StartDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                    disabled={isApproved}
                                />
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày kết thúc *</label>
                                <Calendar
                                    id="EndDate"
                                    name="EndDate"
                                    value={(formData.EndDate && !isNaN(new Date(formData.EndDate).getTime())) ? new Date(formData.EndDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('EndDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                    disabled={isApproved}
                                />
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fdfbf7', border: '1px dashed #e67e22', borderRadius: '6px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: formData.IsConcurrent ? '15px' : '0' }}>
                                <input
                                    type="checkbox"
                                    name="IsConcurrent"
                                    id="IsConcurrent"
                                    checked={formData.IsConcurrent || false}
                                    onChange={handleChange}
                                    style={{ width: '18px', height: '18px', cursor: isApproved ? 'not-allowed' : 'pointer' }}
                                    disabled={isApproved}
                                />
                                <label htmlFor="IsConcurrent" style={{ margin: 0, fontWeight: 'bold', color: '#d35400', cursor: isApproved ? 'not-allowed' : 'pointer' }}>
                                    Bổ sung chức vụ kiêm nhiệm
                                </label>
                            </div>

                            {formData.IsConcurrent && (
                                <div className="concurrent-fields" style={{ borderTop: '1px solid #f39c12', paddingTop: '15px' }}>

                                    <div className="form-group" style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                            Chọn mục giảm trừ kiêm nhiệm
                                        </label>
                                        <Dropdown
                                            id="ConcurrentReductionId"
                                            name="ConcurrentReductionId"
                                            value={formData.ConcurrentReductionId ? Number(formData.ConcurrentReductionId) : null}
                                            options={categoryOptions}
                                            optionLabel="label"
                                            optionValue="value"
                                            onChange={handleConcurrentCategoryChange}
                                            placeholder="Vui lòng chọn mục giảm trừ kiêm nhiệm"
                                            filter
                                            filterPlaceholder="Nhập từ khóa tìm kiếm"
                                            disabled={isApproved}
                                            style={{
                                                width: '100%',
                                                border: '1px solid #cbd5e1',
                                                borderRadius: '6px',
                                                padding: '10px 10px'
                                            }}
                                            panelStyle={{ maxWidth: '650px' }}
                                            itemTemplate={(option) => (
                                                <div style={{ whiteSpace: 'normal', lineHeight: '1.5' }}>
                                                    {option.label}
                                                </div>
                                            )}
                                            emptyMessage="Không có dữ liệu"
                                            emptyFilterMessage="Không tìm thấy kết quả phù hợp"
                                        />
                                    </div>

                                    <div className="form-group" style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Mức giảm trừ chức vụ kiêm nhiệm (%) *</label>
                                        <input
                                            type="number"
                                            step="0.1"
                                            name="ConcurrentPercentage"
                                            className="form-input"
                                            placeholder="Nhập phần trăm..."
                                            value={formData.ConcurrentPercentage !== undefined ? formData.ConcurrentPercentage : ''}
                                            onChange={handleChange}
                                            required={formData.IsConcurrent}
                                            disabled={isApproved}
                                            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>

                                    <div className="form-grid-2" style={{ marginBottom: '0' }}>
                                        <div className="form-group">
                                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày bắt đầu (Kiêm nhiệm) *</label>
                                            <Calendar
                                                id="ConcurrentStartDate"
                                                name="ConcurrentStartDate"
                                                value={(formData.ConcurrentStartDate && !isNaN(new Date(formData.ConcurrentStartDate).getTime())) ? new Date(formData.ConcurrentStartDate) : null}
                                                dateFormat="dd/mm/yy"
                                                showIcon
                                                onChange={(e) => handleDateChange('ConcurrentStartDate', e.value)}
                                                style={{ width: '100%' }}
                                                appendTo={document.body}
                                                panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                                inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                                disabled={isApproved}
                                                required={formData.IsConcurrent}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày kết thúc (Kiêm nhiệm) *</label>
                                            <Calendar
                                                id="ConcurrentEndDate"
                                                name="ConcurrentEndDate"
                                                value={(formData.ConcurrentEndDate && !isNaN(new Date(formData.ConcurrentEndDate).getTime())) ? new Date(formData.ConcurrentEndDate) : null}
                                                dateFormat="dd/mm/yy"
                                                showIcon
                                                onChange={(e) => handleDateChange('ConcurrentEndDate', e.value)}
                                                style={{ width: '100%' }}
                                                appendTo={document.body}
                                                panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                                inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                                disabled={isApproved}
                                                required={formData.IsConcurrent}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="form-group">
                            <label>Ghi chú</label>
                            <textarea
                                name="Notes"
                                className="form-input"
                                rows="3"
                                value={formData.Notes}
                                onChange={handleChange}
                                disabled={isApproved}
                            ></textarea>
                        </div>
                    </form>
                </div>
                <div className="modal-footer" style={{ flexShrink: 0, borderTop: '1px solid #eee' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="urrForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default UserResearchReductionForm;